/** Downward vertical load: the input convention is positive = down (uplift is a separate load). */
export const isDownwardVerticalLoad = (verticalLoad: number | null | undefined): boolean =>
  verticalLoad != null && verticalLoad > 0;

/** The header is laid as a beam (not a column); an orientation not chosen yet does not count. */
export const isBeamHeader = (orientation: string | null | undefined): boolean => orientation === "beam";

/**
 * The wider header-side lock applies only to a MIDI lock under a downward vertical load with a beam header.
 * Mirrors the guard in the backend's computeBOM, which is the authority: this one only decides what the form shows.
 */
export const isHeaderLockApplicable = (
  verticalLoad: number | null | undefined,
  firstLockFamily: string | null | undefined,
  headerOrientation: string | null | undefined,
): boolean => firstLockFamily === "MIDI" && isDownwardVerticalLoad(verticalLoad) && isBeamHeader(headerOrientation);
